import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'brastrap/common/icon/variants/IconDismiss';

const FacetToken = props => (
  <div className="c-facet-token">
    <span className="c-facet-token__label">{props.label}</span>
    <button
      className="c-facet-token__action"
      type="submit"
      onClick={() => props.onRemove(props.label)}
    >
      <Icon />
      <span className="u-hidden"> {`Remove ${props.label}`}</span>
    </button>
  </div>
);

FacetToken.propTypes = {
  onRemove: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

FacetToken.defaultProps = {
  onRemove: () => {},
};

export default FacetToken;
